import React, { Component } from 'react';
import memoize from 'memoize-one';
import Icon from '@atlaskit/icon/glyph/checkbox';
import IconIndeterminate from '@atlaskit/icon/glyph/checkbox-indeterminate';
import GlobalTheme from '@atlaskit/theme/components';
import { IconWrapperOverrides } from './elements';
import Theme, { componentTokens } from './theme';
import { createExtender } from './utils';
const defaults = {
    IconWrapper: IconWrapperOverrides,
    IconIndeterminate: {
        component: IconIndeterminate,
    },
    Icon: {
        component: Icon,
    },
};
export default class CheckboxIcon extends Component {
    constructor(props) {
        super(props);
        this.createExtender = memoize(createExtender).bind(this);
    }
    render() {
        const { isChecked, isDisabled, isInvalid, isActive, isFocused, isHovered, isIndeterminate, overrides, primaryColor, secondaryColor, theme, } = this.props;
        // @ts-ignore
        const getOverrides = this.createExtender(defaults, overrides);
        const { component: IconWrapper, ...iconWrapperOverrides } = getOverrides('IconWrapper');
        const { component: IconIndeterminate } = getOverrides('IconIndeterminate');
        const { component: Icon } = getOverrides('Icon');
        return (React.createElement(Theme.Provider, { value: theme },
            React.createElement(GlobalTheme.Consumer, null, ({ mode }) => (React.createElement(Theme.Consumer, { mode: mode, tokens: componentTokens }, tokens => (React.createElement(IconWrapper, Object.assign({}, iconWrapperOverrides, { tokens: tokens, isChecked: isChecked, isDisabled: isDisabled, isFocused: isFocused, isActive: isActive, isHovered: isHovered, isInvalid: isInvalid }), isIndeterminate ? (React.createElement(IconIndeterminate, { primaryColor: primaryColor, secondaryColor: secondaryColor, size: tokens.icon.size, label: "" })) : (React.createElement(Icon, { primaryColor: primaryColor, secondaryColor: secondaryColor, size: tokens.icon.size, label: "" })))))))));
    }
}
CheckboxIcon.defaultProps = {
    primaryColor: 'inherit',
    secondaryColor: 'inherit',
    isIndeterminate: false,
    theme: (current, props) => current(props),
};
//# sourceMappingURL=CheckboxIcon.js.map